import type {
  AccountPayable,
  AccountReceivable,
  AiGeneration,
  CatalogItem,
  Client,
  Company,
  Expense,
  Lead,
  Measurement,
  Notification,
  Opportunity,
  Project,
  Quote,
  User,
} from "../../types/domain";

export const company: Company = {
  id: "company-1",
  name: "ConstruTech Reformas",
  cnpj: "12.345.678/0001-90",
  phone: "(11) 3333-2026",
  email: "contato@construtech.local",
  address: "Av. Paulista, 1000 — São Paulo - SP",
};
export const users: User[] = [
  {
    id: "user-1",
    name: "Diogo Mendes",
    email: "admin@empreitaflow.local",
    role: "Administrador",
  },
  {
    id: "user-2",
    name: "Carlos Almeida",
    email: "carlos@construtech.local",
    role: "Gestor de Obras",
  },
  {
    id: "user-3",
    name: "Fernanda Lima",
    email: "fernanda@construtech.local",
    role: "Financeiro",
  },
];
export const clients: Client[] = [
  {
    id: "client-1",
    name: "João Oliveira",
    phone: "(11) 99999-9999",
    email: "joao.oliveira@email.com",
    document: "123.456.789-00",
    city: "São Paulo - SP",
    address: "Rua das Acácias, 214 — Moema, São Paulo - SP",
    notes: "Prefere contato pelo WhatsApp no período da tarde.",
    status: "Ativo",
    lastActivity: "2026-08-14",
  },
  {
    id: "client-2",
    name: "Mariana Costa",
    phone: "(11) 98888-4412",
    email: "mariana@email.com",
    document: "987.654.321-00",
    city: "Osasco - SP",
    address: "Rua das Flores, 82 — Osasco - SP",
    notes: "",
    status: "Ativo",
    lastActivity: "2026-08-12",
  },
];
export const leads: Lead[] = [
  {
    id: "lead-1",
    code: "LEAD-2026-0032",
    name: "João Oliveira",
    phone: "(11) 99999-9999",
    email: "joao.oliveira@email.com",
    source: "Indicação",
    service: "Reforma residencial",
    city: "São Paulo - SP",
    owner: "Diogo Mendes",
    notes: "Reforma de sala e cozinha.",
    stage: "Aprovado",
    createdAt: "2026-07-18",
    clientId: "client-1",
    opportunityId: "opp-1",
    estimatedValue: 38500,
    lastInteractionAt: "2026-08-12T14:20:00-03:00",
    nextAction: "Confirmar aprovação da proposta",
  },
  {
    id: "lead-2",
    code: "LEAD-2026-0033",
    name: "Mariana Costa",
    phone: "(11) 98888-4412",
    email: "mariana@email.com",
    source: "Instagram",
    service: "Pintura interna",
    city: "Osasco - SP",
    owner: "Diogo Mendes",
    notes: "Apartamento de 82 m².",
    stage: "Qualificado",
    createdAt: "2026-08-12",
    clientId: "client-2",
    estimatedValue: 7800,
    lastInteractionAt: "2026-08-11T10:30:00-03:00",
    nextAction: "Solicitar fotos do apartamento",
  },
  {
    id: "lead-3",
    code: "LEAD-2026-0034",
    name: "Ricardo Nunes",
    phone: "(11) 97771-3190",
    email: "ricardo@email.com",
    source: "Site",
    service: "Drywall",
    city: "São Paulo - SP",
    owner: "Carlos Almeida",
    notes: "Divisória para escritório.",
    stage: "Novo",
    createdAt: "2026-08-14",
    estimatedValue: 4800,
    lastInteractionAt: "2026-08-14T09:15:00-03:00",
    nextAction: "Realizar primeiro contato",
  },
];
export const opportunities: Opportunity[] = [
  {
    id: "opp-1",
    clientId: "client-1",
    leadId: "lead-1",
    title: "Reforma sala e cozinha",
    service: "Reforma residencial",
    stage: "Aprovação",
    value: 38500,
    createdAt: "2026-07-18",
  },
];
export const measurements: Measurement[] = [
  {
    id: "measurement-1",
    opportunityId: "opp-1",
    mode: "Assistida",
    estimatedArea: 18.6,
    minArea: 17.4,
    maxArea: 19.8,
    confidence: 82,
    status: "Validada",
    items: [
      {
        id: "mi-1",
        description: "Parede principal",
        width: 4.65,
        length: 1,
        height: 4,
        quantity: 1,
        unit: "m²",
        total: 18.6,
      },
    ],
  },
];
export const aiGenerations: AiGeneration[] = [
  {
    id: "ai-1",
    opportunityId: "opp-1",
    version: "V2",
    status: "success",
    service: "Pintura e acabamento",
    environment: "Sala de estar",
    finish: "Fosco premium",
    style: "Contemporâneo",
    approvedAt: "2026-08-14T10:42:00-03:00",
  },
];
export const quotes: Quote[] = [
  {
    id: "quote-1",
    code: "ORC-2026-0018",
    clientId: "client-1",
    opportunityId: "opp-1",
    status: "Enviado",
    displacement: 350,
    discount: 0,
    createdAt: "2026-08-10",
    items: [
      {
        id: "qi-1",
        description: "Drywall",
        quantity: 18.6,
        unit: "m²",
        unitPrice: 145,
        unitCost: 92,
      },
      {
        id: "qi-2",
        description: "Pintura premium",
        quantity: 72,
        unit: "m²",
        unitPrice: 82,
        unitCost: 48,
      },
      {
        id: "qi-3",
        description: "Marcenaria planejada",
        quantity: 1,
        unit: "un",
        unitPrice: 29549,
        unitCost: 18400,
      },
    ],
    versions: [
      { name: "V1", createdAt: "2026-08-10", total: 38199.2 },
      { name: "V2", createdAt: "2026-08-14", total: 38500 },
    ],
    sentAt: "2026-08-14T09:30:00-03:00",
  },
];
export const projects: Project[] = [
  {
    id: "project-1",
    code: "OBR-2026-0014",
    name: "Residência Oliveira",
    clientId: "client-1",
    quoteId: "quote-1",
    owner: "Carlos Almeida",
    address: "Rua das Acácias, 214 — Moema, São Paulo - SP",
    startDate: "2026-07-28",
    endDate: "2026-10-18",
    status: "Em execução",
    contractValue: 38500,
    received: 22000,
    physicalProgress: 68,
    tasks: [
      {
        id: "task-1",
        title: "Finalizar estrutura de drywall",
        description: "Concluir fechamento e preparar juntas.",
        owner: "Carlos Almeida",
        dueDate: "2026-08-16",
        status: "Em Andamento",
        progress: 72,
      },
      {
        id: "task-2",
        title: "Aprovar cor da sala",
        description: "Validar amostra com cliente.",
        owner: "Diogo Mendes",
        dueDate: "2026-08-14",
        status: "Concluídas",
        progress: 100,
      },
    ],
  },
];
export const expenses: Expense[] = [
  {
    id: "expense-1",
    description: "Materiais para drywall",
    category: "Materiais",
    supplier: "Casa do Gesso",
    projectId: "project-1",
    value: 9420,
    date: "2026-08-04",
    paymentMethod: "Pix",
  },
  {
    id: "expense-2",
    description: "Mão de obra — primeira etapa",
    category: "Mão de obra",
    supplier: "Equipe própria",
    projectId: "project-1",
    value: 9000,
    date: "2026-08-08",
    paymentMethod: "Transferência",
  },
];
export const receivables: AccountReceivable[] = [
  {
    id: "ar-1",
    clientId: "client-1",
    projectId: "project-1",
    installment: "Entrada",
    dueDate: "2026-07-28",
    value: 12000,
    status: "Pago",
  },
  {
    id: "ar-2",
    clientId: "client-1",
    projectId: "project-1",
    installment: "2ª parcela",
    dueDate: "2026-08-10",
    value: 10000,
    status: "Pago",
  },
  {
    id: "ar-3",
    clientId: "client-1",
    projectId: "project-1",
    installment: "3ª parcela",
    dueDate: "2026-09-10",
    value: 16500,
    status: "Pendente",
  },
];
export const payables: AccountPayable[] = [
  {
    id: "ap-1",
    supplier: "Tintas Paulista",
    projectId: "project-1",
    category: "Materiais",
    dueDate: "2026-08-20",
    value: 3250,
    status: "Pendente",
  },
];
export const notifications: Notification[] = [
  {
    id: "not-1",
    title: "Conta vencendo",
    description: "Pagamento para Tintas Paulista vence em 6 dias.",
    type: "Conta vencendo",
    read: false,
    createdAt: "2026-08-14T08:20:00-03:00",
    path: "/financeiro/pagar",
  },
  {
    id: "not-2",
    title: "Nova simulação",
    description: "A versão V2 da Residência Oliveira está pronta.",
    type: "Nova simulação",
    read: false,
    createdAt: "2026-08-14T10:42:00-03:00",
    path: "/ai-studio/opp-1",
  },
];
export const services: CatalogItem[] = [
  {
    id: "service-1",
    name: "Instalação de drywall",
    category: "Construção seca",
    unit: "m²",
    price: 145,
  },
  {
    id: "service-2",
    name: "Pintura premium",
    category: "Pintura",
    unit: "m²",
    price: 82,
  },
];
export const materials: CatalogItem[] = [
  {
    id: "material-1",
    name: "Chapa drywall ST 12,5 mm",
    category: "Drywall",
    unit: "un",
    price: 68.9,
  },
  {
    id: "material-2",
    name: "Tinta acrílica premium 18 L",
    category: "Pintura",
    unit: "lata",
    price: 489,
  },
];
export const suppliers: CatalogItem[] = [
  {
    id: "supplier-1",
    name: "Casa do Gesso",
    category: "Drywall",
    phone: "(11) 3333-8821",
    email: "vendas@casadogesso.local",
  },
  {
    id: "supplier-2",
    name: "Tintas Paulista",
    category: "Pintura",
    phone: "(11) 3222-7710",
    email: "contato@tintaspaulista.local",
  },
];
